import * as actionTypes from "./actionTypes";

export const investTechPoint = (technologyId: number) => ({
  type: actionTypes.INVEST_TECH_POINT,
  technologyId
})
